import { Perfil } from '@/utils/constants.utils.js';
const items = [
    {
        title: 'Regiões de Análise',
        icon: 'mdi-earth',
        link: '/regiao',
        codigo: 'REGIOES_ANALISE',
        disabled: false,
        visible: true,
        perfis: [Perfil.ADMINISTRADOR_ANALISE],
    },
    {
        title: 'Pagina Inicial',
        icon: 'mdi-home',
        link: '/pagina-inicial',
        codigo: 'PAGINA-INICIAL',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL],
    },
    {
        title: 'Caixa de entrada',
        icon: 'mdi-inbox',
        link: '/caixa-entrada',
        codigo: 'CAIXA_ENTRADA',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL],
    },
    {
        title: 'Análise',
        icon: 'mdi-clipboard-file-outline',
        link: '/analise-vinculo',
        codigo: 'ANALISE_VINCULO',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL],
    },
    {
        title: 'Validação da proposta',
        icon: 'mdi-sticker-check-outline',
        link: '/validacao-proposta',
        codigo: 'VALIDACAO_PROPOSTA',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL],
    },
    {
        title: 'Termo de compromisso',
        icon: 'mdi-file-document-outline',
        link: '/termo-compromisso',
        codigo: 'TERMO_COMPROMISSO',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL],
    },
    {
        title: 'Análise da proposta',
        icon: 'mdi-text-box-search-outline',
        link: '/analise-proposta',
        codigo: 'ANALISE_PROPOSTA',
        disabled: false,
        visible: true,
        perfis: [Perfil.TECNICO],
    },
    {
        title: 'Em Reanálise',
        icon: 'mdi-file-document-refresh-outline',
        link: '/reanalise-proposta',
        codigo: 'REANALISE_PROPOSTA',
        disabled: false,
        visible: true,
        perfis: [Perfil.TECNICO],
    },
    {
        title: 'Consultar processos',
        icon: 'mdi-text-box-search-outline',
        link: '/consultar-processos',
        codigo: 'CONSULTAR_PROCESSOS',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL, Perfil.TECNICO, Perfil.SEMIL],
    },
    {
        title: 'Tipos de Documentos',
        icon: 'mdi-file-document-outline',
        link: '/tipo-documento',
        codigo: 'TIPO_DOCUMENTO',
        disabled: false,
        visible: true,
        perfis: [Perfil.ADMINISTRADOR_ANALISE],
    },
    {
        title: 'Migração de Processos',
        icon: 'mdi-file-swap',
        link: '/migracao-processos',
        codigo: 'MIGRACAO_PROCESSOS',
        disabled: false,
        visible: true,
        perfis: [Perfil.ADMINISTRADOR_ANALISE],
    },
    {
        title: 'Monitoramento Prada',
        icon: 'mdi-file-swap',
        link: '/monitoramento-prada',
        codigo: 'MONITORAMENTO_PRADA',
        disabled: false,
        visible: true,
        perfis: [Perfil.GERENTE_OPERACIONAL, Perfil.TECNICO],
    },
];

export { items };
